module.exports = __webpack_public_path__ + "img/pre_left.1b512231.png";